// extracted by mini-css-extract-plugin
module.exports = {"remoteButton":"Locations_remoteButton__R4Rxz"};